import React, { useMemo, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Nav, Navbar } from 'react-bootstrap';
import { AuthContext } from '../../contexts/AuthContext';
import { ThemeContext } from '../../contexts/ThemeContext';
import { useDispatch } from 'react-redux';
import { setQ } from '../../reducers/searchSlice';
import debounce from 'lodash.debounce';
import './index.css';

export default function NavBar({ loginPage, search }) {
  const { user } = useContext(AuthContext);
  const themeContext = useContext(ThemeContext);
  const dispatch = useDispatch();
  // console.log(user);

  const handleChange = (e) => {
    dispatch(setQ(e.target.value));
  };

  const debouncedResults = useMemo(() => {
    return debounce(handleChange, 300);
  }, []);

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Navbar
      collapseOnSelect
      expand='lg'
      //   bg='dark'
      variant='dark'
      className='nav_bar'
    >
      {/* <Container> */}
      <Navbar.Brand className='logo'>
        <Link to='/'>
          <img src={themeContext?.logo ?? '/assets/imgs/logo.png'} alt='logo' />
          {/* <img src={themeContext?.logo} alt='logo' /> */}
        </Link>
      </Navbar.Brand>
      {!loginPage && (
        <>
          <Navbar.Toggle aria-controls='responsive-navbar-nav' />
          <Navbar.Collapse id='responsive-navbar-nav'>
            <Nav className='me-auto'>
              {/* {search && (
                <FormControl variant='standard'>
                  <Input
                    placeholder='Search'
                    className='nav_search'
                    id='input-with-icon-adornment'
                    onChange={debouncedResults}
                    endAdornment={
                      <InputAdornment className='nav_search_svg' position='end'>
                        <svg
                          width='22'
                          height='22'
                          viewBox='0 0 22 22'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M10.0833 17.4167C14.1334 17.4167 17.4167 14.1334 17.4167 10.0833C17.4167 6.03325 14.1334 2.75 10.0833 2.75C6.03325 2.75 2.75 6.03325 2.75 10.0833C2.75 14.1334 6.03325 17.4167 10.0833 17.4167Z'
                            stroke='#4FC8E9'
                            strokeWidth='1.83333'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                          <path
                            d='M19.2497 19.25L15.2622 15.2625'
                            stroke='#4FC8E9'
                            strokeWidth='1.83333'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                        </svg>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              )} */}
            </Nav>
            <Nav className='nav_buttons'>
              {!user && (
                <Link to='/login' className='login_nav_btn'>
                  Login
                </Link>
              )}
              {/* <Link to='/feature_cars'>Featured Cars</Link> */}
              {/* <Link to='/about_us'>About Us</Link> */}
              <Link to='/contact_us'>Contact Us</Link>
              {/* <Link to='/register' className='login_nav_btn'>
                Register
              </Link> */}
              {/* {user && (
                <div
                  className='setting header_btn'
                  onClick={() => navigate('/settings')}
                >
                  <svg
                    width='26'
                    height='26'
                    viewBox='0 0 26 26'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M14.971 23.8334H11.0277C10.7806 23.8334 10.5409 23.749 10.3484 23.5941C10.1559 23.4392 10.0221 23.2232 9.96926 22.9819L9.52835 20.9409C8.94016 20.6831 8.38243 20.3608 7.86543 19.9799L5.87535 20.6137C5.63979 20.6888 5.38562 20.6811 5.15506 20.5918C4.92449 20.5025 4.7314 20.3371 4.60785 20.1229L2.63185 16.7094C2.50959 16.495 2.46369 16.2455 2.50167 16.0017C2.53966 15.7578 2.65926 15.5341 2.84093 15.3671L4.38468 13.9588C4.31448 13.3208 4.31448 12.6771 4.38468 12.0391L2.84093 10.634C2.65901 10.4669 2.53924 10.243 2.50125 9.99895C2.46326 9.75489 2.50931 9.50515 2.63185 9.29069L4.60351 5.87494C4.72707 5.66078 4.92016 5.49533 5.15073 5.40606C5.38129 5.31679 5.63546 5.30907 5.87101 5.38419L7.8611 6.01794C8.12543 5.82294 8.4006 5.64094 8.68443 5.47627C8.95851 5.32244 9.24018 5.18269 9.52835 5.0581L9.97035 3.01927C10.023 2.7779 10.1565 2.56177 10.3488 2.4067C10.5411 2.25163 10.7806 2.16695 11.0277 2.16669H14.971C15.2181 2.16695 15.4576 2.25163 15.6499 2.4067C15.8422 2.56177 15.9757 2.7779 16.0283 3.01927L16.4747 5.05919C17.0621 5.31839 17.6197 5.64059 18.1376 6.0201L20.1288 5.38635C20.3642 5.31151 20.6181 5.31937 20.8484 5.40863C21.0788 5.49788 21.2717 5.66318 21.3952 5.8771L23.3668 9.29285C23.6182 9.73377 23.5315 10.2917 23.1578 10.6351L21.614 12.0434C21.6842 12.6814 21.6842 13.3251 21.614 13.9631L23.1578 15.3714C23.5315 15.7159 23.6182 16.2728 23.3668 16.7137L21.3952 20.1294C21.2716 20.3436 21.0785 20.509 20.848 20.5983C20.6174 20.6876 20.3632 20.6953 20.1277 20.6202L18.1376 19.9864C17.621 20.3671 17.0636 20.689 16.4758 20.9463L16.0283 22.9819C15.9755 23.223 15.8419 23.4389 15.6496 23.5938C15.4573 23.7486 15.2179 23.8331 14.971 23.8334ZM12.995 8.66669C11.8457 8.66669 10.7435 9.12323 9.93088 9.93589C9.11823 10.7485 8.66168 11.8507 8.66168 13C8.66168 14.1493 9.11823 15.2515 9.93088 16.0642C10.7435 16.8768 11.8457 17.3334 12.995 17.3334C14.1443 17.3334 15.2465 16.8768 16.0591 16.0642C16.8718 15.2515 17.3283 14.1493 17.3283 13C17.3283 11.8507 16.8718 10.7485 16.0591 9.93589C15.2465 9.12323 14.1443 8.66669 12.995 8.66669Z'
                      fill='#4FC8E9'
                    />
                  </svg>
                </div>
              )} */}
            </Nav>
          </Navbar.Collapse>
        </>
      )}
      {/* </Container> */}
    </Navbar>
  );
}
